import { render } from "./PaperclipIcon.vue?vue&type=template&id=c16d0c62"
import script from "./PaperclipIcon.vue?vue&type=script&lang=js"
export * from "./PaperclipIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__